import React from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell
} from 'recharts';
import './CompletionRateChart.css';

const CompletionRateChart = ({ data, title, xAxisLabel = 'PPD' }) => {
  // Transform data for the chart
  const chartData = data.map(item => ({
    name: item.code,
    completed: item.completed || 0,
    inProgress: item.inProgress || 0,
    notStarted: item.notStarted || 0,
    total: item.total || 0
  }));

  // Custom tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const total = payload[0].payload.total;
      return (
        <div className="chart-tooltip">
          <p className="tooltip-label"><strong>{label}</strong></p>
          <p className="tooltip-completed">
            <span className="dot completed"></span>
            Completed: {payload[0].value} grades ({total > 0 ? Math.round((payload[0].value / total) * 100) : 0}%)
          </p>
          <p className="tooltip-wip">
            <span className="dot wip"></span>
            WIP: {payload[1].value} grades ({total > 0 ? Math.round((payload[1].value / total) * 100) : 0}%)
          </p>
          <p className="tooltip-not-started">
            <span className="dot not-started"></span>
            Not Started: {payload[2].value} grades ({total > 0 ? Math.round((payload[2].value / total) * 100) : 0}%)
          </p>
          <p className="tooltip-total">
            <strong>Total: {total} grades</strong>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="completion-rate-chart">
      <h4>{title}</h4>
      <ResponsiveContainer width="100%" height={400}>
        <BarChart
          data={chartData}
          margin={{ top: 20, right: 30, left: 20, bottom: 80 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="name"
            angle={-45}
            textAnchor="end"
            height={100}
            interval={0}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            label={{ value: 'Grades/Tahun', angle: -90, position: 'insideLeft' }}
            allowDecimals={false}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend
            wrapperStyle={{ paddingTop: '20px' }}
            formatter={(value) => {
              if (value === 'completed') return 'Completed';
              if (value === 'inProgress') return 'WIP';
              if (value === 'notStarted') return 'Not Yet Started';
              return value;
            }}
          />
          <Bar dataKey="completed" stackId="a" fill="#5cb85c" name="completed" />
          <Bar dataKey="inProgress" stackId="a" fill="#f0ad4e" name="inProgress" />
          <Bar dataKey="notStarted" stackId="a" fill="#d9534f" name="notStarted" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default CompletionRateChart;
